<script setup lang="ts">
import { Check, Send } from 'lucide-vue-next'

// A transfer travelling from Bishkek abroad
const { t } = useI18n()

const countries = ['russia', 'kazakhstan', 'turkey'] as const
</script>

<template>
  <div class="relative w-[21rem] select-none" aria-hidden="true">
    <div class="HeroIllustrationCard">
      <div class="flex items-center justify-between">
        <div class="text-sm text-gray-500">{{ t('widget.hero_banner.illustration.money_transfers.sent') }}</div>
        <span class="grid size-9 place-items-center rounded-full bg-blue-600 text-white">
          <Send class="size-4" />
        </span>
      </div>
      <div class="font-serif text-2xl font-bold">10 000 {{ t('widget.hero_banner.illustration.som') }}</div>

      <div class="mt-4 flex items-center gap-3">
        <div class="text-sm font-semibold">{{ t('widget.hero_banner.illustration.money_transfers.from') }}</div>
        <div class="relative h-px flex-1 border-t-2 border-dashed border-blue-200">
          <span class="absolute -top-[0.4rem] left-2/3 size-3 rounded-full bg-blue-600 ring-4 ring-blue-100" />
        </div>
        <div class="text-sm font-semibold">{{ t('widget.hero_banner.illustration.money_transfers.to') }}</div>
      </div>

      <div class="mt-4 flex items-center gap-2 rounded-xl bg-green-50 px-3 py-2 text-sm font-semibold text-green-700">
        <Check class="size-4" />
        {{ t('widget.hero_banner.illustration.money_transfers.delivered') }}
      </div>
    </div>

    <div class="absolute -bottom-5 -left-8 flex gap-1.5">
      <span
        v-for="country in countries"
        :key="country"
        class="rounded-xl bg-brand-gray px-3 py-1.5 text-sm font-semibold text-white shadow-lg"
      >
        {{ t(`widget.hero_banner.illustration.money_transfers.${country}`) }}
      </span>
    </div>
  </div>
</template>
